<template>
  <!-- footer -->
  <footer class="inc_footer">
    <div class="violation-wrap">
      <a
        id="violation-link"
        class="report-violation-link"
        href="https://abuse.mag2.com/report/violation"
        style="display: none;"
        >メルマガの不正・違反報告はこちらまで</a
      >
    </div>
    <div class="-inner">
      <ul class="-list">
        <li class="-item"><a href="http://www.mag2.co.jp/">会社案内</a></li>
        <li class="-item">
          <a href="https://www.mag2.com/info/">まぐまぐからのお知らせ</a>
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/service.html"
            >WEBサイト利用規約</a
          >
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/member.html">会員規約</a>
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/reader.html"
            >無料メルマガ登録規約</a
          >
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/publisher.html"
            >メルマガ発行規約</a
          >
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/antisocial.html"
            >反社会的勢力排除宣言</a
          >
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/privacy.html"
            >プライバシーポリシー</a
          >
        </li>
        <li class="-item">
          <a href="https://www.mag2.com/terms/trade.html">特定商取引法</a>
        </li>
        <li class="-item">
          <a href="https://www.mag2.co.jp/service/advertising/"
            >広告掲載はこちら</a
          >
        </li>
      </ul>
      <div class="-credit">
        ページ内の商標は全て商標権者に属します。 <br />© 1999-{{ item.year }}
        Magmag, Inc.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* --------
  footer
-----------*/
.inc_footer {
  margin-top: 40px;
  background-color: #f2f2f2;
  clear: both;
  font-family: '游ゴシック', YuGothic, 'ヒラギノ角ゴ Pro',
    'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', sans-serif;
  font-weight: normal;
  line-height: 1.6;
}
.inc_footer .-inner {
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  font-size: 13px;
  color: #333;
  box-sizing: border-box;
}

/* reset */
.inc_footer ul,
.inc_footer li {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* media querie diplay */
.pc_none {
  display: none;
}
.pc_block {
  display: block;
}

/* link */
.inc_footer a {
  color: #333;
  text-decoration: none;
  font-weight: normal;
}
.inc_footer a:hover {
  color: #0077cc;
  text-decoration: underline;
  transition: 400ms;
}

/* ------------
  list
--------------- */
.inc_footer .-inner .-list {
  text-align: center;
}
.inc_footer .-inner .-list .-item {
  display: inline-block;
}
.inc_footer .-inner .-list .-item a {
  margin: 5px 0;
  padding: 0 6px;
  display: inline-block;
  border-right: 1px solid #ccc;
}
.inc_footer .-inner .-list .-item:last-child a {
  border-right: none;
}
.inc_footer .-inner .-credit {
  padding-top: 20px;
  text-align: center;
}

/* ===================

違反フォーム

=====================*/

.violation-wrap {
  padding: 10px 0;
  text-align: center;
  background: #ff3e3e;
}

.inc_footer .report-violation-link {
  color: #fff;
}

/* =====================

   tablet / mobile

===================== */

@media screen and (max-width: 768px) {
  /* ------------
  common
--------------- */
  .inc_footer .-inner {
    margin: 0 auto;
    padding: 0;
  }

  /* media querie diplay */
  .sp_none {
    display: none;
  }
  .sp_block {
    display: block;
  }

  /* link */
  .inc_footer a {
    display: block;
    color: #333;
  }
  .inc_footer a:hover {
    text-decoration: none;
  }

  /* ------------
  list
--------------- */
  .inc_footer .-inner .-list .-item {
    display: block;
    border-bottom: 1px solid #ccc;
  }
  .inc_footer .-inner .-list .-item:first-child {
    border-top: 1px solid #ccc;
  }
  .inc_footer .-inner .-list .-item:hover {
    background: #fff;
    transition: 1000ms;
  }
  .inc_footer .-inner .-list .-item a {
    display: block;
    margin: 0;
    padding: 15px 20px;
    border-right: 0;
  }
  .inc_footer .-inner .-list .-item a:before {
    content: '>';
    color: #ccc;
    padding-right: 1em;
  }
  .inc_footer .-inner .-credit {
    padding: 20px;
    text-align: left;
  }
  .inc_footer .-inner .-credit a {
    display: inline;
  }
}
</style>
